import { render, staticRenderFns } from "./RecentlyModifiedFamilies.vue?vue&type=template&id=78bfbec0&scoped=true&"
import script from "./RecentlyModifiedFamilies.vue?vue&type=script&lang=ts&"
export * from "./RecentlyModifiedFamilies.vue?vue&type=script&lang=ts&"
import style0 from "./RecentlyModifiedFamilies.vue?vue&type=style&index=0&id=78bfbec0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bfbec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText,VCardTitle})
